import { render, staticRenderFns } from "./ThankYouSubscribePriority.vue?vue&type=template&id=64878cb4&scoped=true&"
import script from "./ThankYouSubscribePriority.vue?vue&type=script&lang=js&"
export * from "./ThankYouSubscribePriority.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouSubscribePriority.vue?vue&type=style&index=0&id=64878cb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64878cb4",
  null
  
)

export default component.exports